import React from "react";
import "./dataSearchList.scss";

const WarehouseSearchList = ({ data, onSelectDataHandler, setShowList, setAddressRefValue }) => {
    const addItemHandler = (item) => {
        onSelectDataHandler(item?.Present || item.Description);
        setShowList(false);
        setAddressRefValue(item.Ref);
    };

    return (
        <div className="dataSearchList">
            <ul className="list-group">
                {data.map((item) => {
                    return (
                        <li
                            className="list-group-item custom-list-item"
                            key={item.id}
                            onClick={() => addItemHandler(item)}
                        >
                            {item.Present}
                            {item.Description}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default WarehouseSearchList;
